/* Redux */
import { useSelector, useDispatch } from 'src/redux/hooks'
import { useRecommendationTracking } from 'src/context/RecommendationTrackingContext'

/* Types */
import { tItem } from 'src/shared/frontendTypes/warenkorb'

const Redux = () => {
  const dispatch = useDispatch()
  const recommendation = useRecommendationTracking()

  const items = useSelector(store => store.Warenkorb.items)
  const getItem = (key: string) => items[key]

  const addItem = (item:tItem) =>
    dispatch({ type: 'addWarenkorbItem', payload: item, ...(recommendation ? { meta: { recommendation } } : {}) })

  return { getItem, addItem }
}

export default Redux
